/*
common/lib/utils/elements

usage:

return:
*/
function matchInArr(str, arrWithStrings) {
	const L = (arrWithStrings && arrWithStrings.length);
	let i;
	let indexMatch = false;
	if (L) {
		for (i = 0; i < L; i += 1) {
			if (arrWithStrings[i] === str && !indexMatch) {
				indexMatch = true;
				// exit the loop preferrably
			}
		}
	}
	return indexMatch;
}

function isObject(obj) {
	/* a separation of object and array, '{}' vs '[]'*/
	return Boolean(obj && (obj === Object(obj) && Object.prototype.toString.call(obj) !== '[object Array]'));
}

function isElement(elm) {
	return Boolean(elm && elm.nodeType && elm.nodeType === 1);
}

function validElement(p, key, modulenameUsingTheMethod) {
	let element = null;
	const errorMsg = `${modulenameUsingTheMethod} :core:elements:validElement: not valid`;
	// if (p[key] && p[key].nodeType && p[key].nodeType === 1) {
	if (isElement(p[key])) {
		element = p[key];
	} else {
		console.error(errorMsg, key);
	}
	return element;
}

function deleteElement(elm) { // modulenameUsingTheMethod) {
	// const errorMsg = `${modulenameUsingTheMethod} :core:elements:deleteElement: can not delete`;
	// let element = ((elm.nodeType && elm.nodeType === 1 && elm.parentNode) ? elm : null);
	let element = (isElement(elm) ? elm : null);
	if (element) {
		element.parentNode.removeChild(element);
		element = null;
	} else {
		// console.warn(errorMsg, elm);
	}
	return element;
}

function deleteElements(arrObjElm) {
	let newElm = null;
	if (Array.isArray(arrObjElm)) {
		newElm = [];
		arrObjElm.forEach((elm) => {
			newElm[elm] = deleteElement(elm);
		});
	} else if (!isElement(arrObjElm) && isObject(arrObjElm)) {
		newElm = {};
		Object.keys(arrObjElm).forEach((elm) => {
			newElm[elm] = deleteElement(arrObjElm[elm]);
		});
	} else if (isElement(arrObjElm)) {
		newElm = deleteElement(arrObjElm);
	}
	return newElm;
}

function deleteElementsInObject(elements, exceptKeysArr) { // , modulenameUsingTheMethod) {
	// const errorMsg = `${modulenameUsingTheMethod} : deleteElementsInObject: error:`;
	const newElements = {};
	if (elements) {
		Object.keys(elements).forEach((key) => {
			try {
				if (matchInArr(key, exceptKeysArr)) {
					newElements[key] = elements[key];
				} else {
					newElements[key] = deleteElements(elements[key]);
				}
			} catch (err) {
				// silent catch
				// console.warn(errorMsg + key, err);
				newElements[key] = null;
			}
		});
	}
	return newElements;
}

function selectElements(selectors, modulenameUsingTheMethod) {
	/* return selected dom-nodes from an object of selectors */
	const elements = {};
	const errorMsg = `${modulenameUsingTheMethod} : can not find element`;
	Object.keys(selectors).forEach((key) => {
		const selector = selectors[key];
		if (selector) {
			try {
				if (selector[0] === '#') {
					elements[key] = document.querySelector(selector);
				} else if (selector[0] === '.') {
					elements[key] = document.querySelectorAll(selector);
				}
			} catch (err) {
				console.error(errorMsg, selector);
			}
		}
	});
	return elements;
}

export default {
	deleteElement(elm, modulenameUsingTheMethod) {
		return deleteElement(elm, modulenameUsingTheMethod);
	},
	deleteElementsInObjectExcept(obj, keysToIgnoreArr, modulenameUsingTheMethod) {
		/* OBSERVE that this method currently only works for almost flat objects. There
		is no recursion done to traverse a complex object. */
		return deleteElementsInObject(obj, keysToIgnoreArr, modulenameUsingTheMethod);
	},
	getElementInObjectIfValid(obj, key, modulenameUsingTheMethod) {
		return validElement(obj, key, modulenameUsingTheMethod);
	},
	selectElements(objWithSelectors, modulenameUsingTheMethod) {
		return selectElements(objWithSelectors, modulenameUsingTheMethod);
	},
	isElement(elm) {
		return isElement(elm);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/elements.js